"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  makeMetadataPayload: true
};
exports.default = instantiate;
exports.makeMetadataPayload = makeMetadataPayload;

var _util = require("./util");

Object.keys(_util).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _util[key];
    }
  });
});

var _metadata = require("./metadata");

Object.keys(_metadata).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _metadata[key];
    }
  });
});

var _regulations = require("./regulations");

Object.keys(_regulations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _regulations[key];
    }
  });
});

var _getCookiesHash = require("./getCookiesHash");

Object.keys(_getCookiesHash).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getCookiesHash[key];
    }
  });
});

var _queryString = require("./queryString");

Object.keys(_queryString).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _queryString[key];
    }
  });
});

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function instantiate() {
  (0, _util.setSearchParamsCookie)();
  (0, _util.setReferrerCookie)();
}

function makeMetadataPayload(params) {
  return _objectSpread({}, (0, _metadata.getWeWorkLeadMetadataFromCookies)(params), {
    full_url: (0, _util.getURL)(),
    locale: (0, _util.getLocale)(),
    submission_timestamp: (0, _util.getTimestamp)()
  });
} // WIP
// export * from './constants/dictionary';